import React from "react";
import ListBox from "components/common/Form/ListBox/ListBox";
import styles from "./ExportButton.module.css";

interface Props {
    exportCsv: () => void;
}

const ExportButton = ({ exportCsv }: Props) => (
    <div className={styles.container}>
        <ListBox
            {...{
                name: "ListBox",
                items: [{ id: 1, value: "csv", label: "CSV" }],
                error: false,
                disabled: false,
                onSelect: () => {
                    exportCsv();
                },
                selectedItem: { id: "null", value: "null", label: "Export as" },
            }}
            styleOverride={styles.exportButton}
        />
    </div>
);

export default ExportButton;
